module.exports = __webpack_public_path__ + "static/media/C9.7500160b.jpg";